module.exports = __webpack_public_path__ + "img/라이브4.f937c231.jpg";